import { BoxRollType, GroupType, ProductType } from "store";
import { entries } from "utils/helper";

interface ErrorProductType extends ProductType {
  idFile: number;
}

type ErrorProducts = {
  uid: number;
  items: ErrorProductType[];
};
export type ErrorProductsProps = ErrorProducts;

type ObjectCheckSize = ProductType["size"];

interface ObjectCheck extends ObjectCheckSize {
  qty: string | number;
  weight: string | number | null;
}

const useAppHook = () => {
  const getSimpleType = (type: BoxRollType): "box" | "roll" => {
    switch (type) {
      case "box":
      case "sacks":
      case "bigbags":
      case "bulk":
        return "box";

      case "roll":
      case "pipes":
      case "barrels":
        return "roll";

      default:
        return "box";
    }
  };

  const getIsErrorItem = (type: "box" | "roll") => (name: string, objectCheck: ObjectCheck) => {
    let isError = false;

    if (!name) isError = true;

    const checkSizeByType = {
      box: ["qty", "weight", "height", "length", "width"],
      roll: ["qty", "weight", "height", "diameter"],
    };

    entries(objectCheck).map(([variable, state]) => {
      if (checkSizeByType[type].some((value) => value === variable)) {
        if (!state || !+state) isError = true;
      }
    });

    return isError;
  };

  const validate = (groups: (GroupType | ErrorProducts)[]) => {
    const errorData: ErrorProducts[] = [];

    groups.map(({ uid, items }: GroupType | ErrorProducts) => {
      const products: ErrorProductType[] = [];

      items.map((item, index) => {
        const { name, size, type, qty, weight } = item;
        const checkType = getSimpleType(type);

        const isError = getIsErrorItem(checkType)(name, { ...size, qty, weight });
        if (isError) products.push({ ...item, idFile: index + 1 });
      });

      if (products.length) errorData.push({ uid, items: products });
    });

    return errorData;
  };

  const mergeGroup = (corrected: ErrorProducts[], groups: GroupType[]): GroupType[] => {
    return groups.map((currentGroup) => {
      const { uid, items } = currentGroup;
      const group = corrected.find((item) => item.uid === uid);

      if (!group) return currentGroup;

      const mergedItems = items.map((item) => {
        const findModifyItem = group.items.find(({ uid }) => uid === item.uid);
        return findModifyItem ?? item;
      });

      return {
        ...currentGroup,
        items: mergedItems,
      };
    });
  };

  return { validate, mergeGroup };
};

export { useAppHook };
